module.exports = __webpack_public_path__ + "static/media/apple-music-badge.0d25cc45.svg";